import {Component, Input} from '@angular/core';

@Component({
  selector: "MultiToggle",
  templateUrl: './multitoggle.component.html',
  styleUrls: ['./multitoggle.component.scss'],
})
export class MultiToggle {

  @Input() onChange: any;
  @Input() options: Array<string>;
  @Input() option: number;
  @Input() hideIcon: boolean = false;
  @Input() hideText: boolean = false;

  public state = {
    'selected': 0
  };

  constructor() {
    this.changeToggle = this.changeToggle.bind(this);
  }

  ngOnChanges(changes) {
    if (changes.option) {
      this.state.selected = changes.option.currentValue;
    }
  }

  changeToggle(value) {
    const index = this.options.indexOf(value);
    if (index === -1) {
      return;
    }
    this.state.selected = index;
    this.onChange(value);
  }
}
